import React from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";

const Unauthorized = () => {
  const navigate = useNavigate();
  
  return (
    <Result
      status="403"
      title="403"
      subTitle="Désolé, vous n'êtes pas autorisé à accéder à cette page."
      extra={
        <>
          <Button type="primary" onClick={() => navigate("/dashboard")}>
            Retour au tableau de bord
          </Button>
          <Button style={{ marginLeft: "10px" }} onClick={() => navigate("/login")}>
            Aller à la page de connexion
          </Button>
        </>
      }
    />
  );
};

export default Unauthorized;